import { httpClient } from '@/network/clientController'

/** Pay emis reference
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_paymentsemisreferences%7Brid%7Dentity%7Bid%7Dpay
*/
export const payEmisReference = (payload) => {
	return httpClient({
		method: 'POST',
		url: `/payments/emis/reference/${payload.reference}/entity/${payload.entityId}/pay`,
        data: payload.data,
		operationTypeId: 19001 /* for mocks handling of tokens */
	})
}

/** Get emis vouchers for payment operator
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_paymentsemisvouchersentity%7Bid%7D
*/
export const getEmisVouchersList = (payload) => {
	return httpClient({
		method: 'GET',
		url: `/payments/emis/vouchers/entity/${payload.entityId}`,
        data: payload.data,
		isCancellable: true
	})
}

/** Pay emis voucher
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_paymentsemisvouchersentity%7Bid%7Dcode%7Bcode%7Dpay
*/
export const payEmisVoucher = (payload) => {
	return httpClient({
		method: 'POST',
		url: `/payments/emis/vouchers/entity/${payload.entityId}/code/${payload.code}/pay`,
        data: payload.data,
		operationTypeId: 19002 /* for mocks handling of tokens */
	})
}

/** Get emis special products for payment operator
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_paymentsemisspecialentity%7Bid%7D
*/
export const getEmisSpecialProductsList = (payload) => {
	return httpClient({
		method: 'GET',
		url: `/payments/emis/special/entity/${payload.entityId}`,
		isCancellable: true
	})
}

/** Get emis special products values for payment operator
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_paymentsemisspecialentity%7Bid%7Dproduct%7Bpid%7D
*/
export const getEmisSpecialProductsValuesList = (payload) => {
	return httpClient({
		method: 'GET',
		url: `/payments/emis/special/entity/${payload.entityId}/product/${payload.pid}`,
		isCancellable: true
	})
}

/** Pay emis special
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_paymentsemisspecialentity%7Bid%7Dproduct%7Bpid%7Dcode%7Bcode%7Dpay
*/
export const payEmisSpecial = (payload) => {
	return httpClient({
		method: 'POST',
		url: `/payments/emis/special/entity/${payload.entityId}/product/${payload.pid}/code/${payload.code}/pay`,
        data: payload.data,
		operationTypeId: 19004 /* for mocks handling of tokens */
	})
}
